import { useState } from "react";
import { Box, Typography } from "@mui/material";
import WalletBG from "@/assets/image/WalletBG.jpg";
import { styles } from "./stylesWalletTab";
// import ArrowInCircleSvg from "@/assets/svg/ArrowInCircleSvg";
// import ArrowInCircleDiagonalSvg from "@/assets/svg/ArrowInCircleDiagonalSvg";
// import ReceiveModal from "@/components/UI/modal/Wallet/ModalInWalletPage/ReceiveModal";
// import SendModal from "@/components/UI/modal/Wallet/ModalInWalletPage/SendModal";
import BuyModal from "@/components/UI/modal/Wallet/ModalInWalletPage/BuyModal";
import { useGetWalletBalanceQuery } from "@/store/api/walletApi";
// import BTCSvg from "@/assets/svg/Coins/BTCSvg";
import SwapModal from "@/components/UI/modal/Wallet/ModalInWalletPage/SwapModal";
import { formatMoney } from "@/helpers/formatMoney";

const WalletTab = () => {
  // const [showReceiveModal, setShowReceiveModal] = useState(false);
  // const [showSendModal, setShowSendModal] = useState(false);
  const [showBuyModal, setShowBuyModal] = useState(false);
  const [swapOpen, setSwapOpen] = useState(false);

  const { data: walletData, isLoading } = useGetWalletBalanceQuery();
  const usdBalance = Number(walletData?.balance) || 0;

  return (
    <>
      {/* {showReceiveModal && (
        <Box sx={styles.modalOverlay} onClick={() => setShowReceiveModal(false)}>
          <Box onClick={(e) => e.stopPropagation()}>
            <ReceiveModal onClose={() => setShowReceiveModal(false)} currency="BTC" />
          </Box>
        </Box>
      )} */}
      {/* {showSendModal && (
        <SendModal
          onClose={() => setShowSendModal(false)}
          currency="BTC"
          icon={<BTCSvg />}
          refetchBalance={refetchBalance}
        />
      )} */}
      {showBuyModal && <BuyModal onClose={() => setShowBuyModal(false)} />}
      <SwapModal
        open={swapOpen}
        onClose={() => setSwapOpen(false)}
        onConfirm={({ from, to }) => {
          console.log("swap:", from, "→", to);
          setSwapOpen(false);
        }}
      />

      <Box sx={styles.walletBox}>
        <Box sx={{ ...styles.walletInnerBox, backgroundImage: `url(${WalletBG})` }}>
          <Box sx={styles.centerBox}>
            <Typography sx={styles.satsLabel}>USDC</Typography>
            <Typography sx={styles.balanceTitle}>Balance</Typography>
            <Typography sx={styles.balanceAmount}>
              {isLoading ? "Loading..." : `$${formatMoney(usdBalance)}`}
            </Typography>
          </Box>
        </Box>

        {/* <Box sx={styles.sendReceiveBox}>
          <Box sx={styles.receiveBtn} onClick={() => setShowReceiveModal(true)}>
            <ArrowInCircleSvg /> Receive
          </Box>
          <Box sx={styles.sendBtn} onClick={() => setShowSendModal(true)}>
            <ArrowInCircleDiagonalSvg /> Send
          </Box>
        </Box> */}
      </Box>
    </>
  );
};

export default WalletTab;
